module.exports = __webpack_public_path__ + "img/CebuBohol2024.c6aad6e4.jpg";